import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilter, faSearch, faSortAmountDown } from "@fortawesome/free-solid-svg-icons";

const SORT_OPTIONS = [
  { value: "newest", label: "Newest" },
  { value: "oldest", label: "Oldest" },
  { value: "most_resources", label: "Most Resources" },
];

const STATUS_OPTIONS = [
  { value: "", label: "All Statuses" },
  { value: "ACTIVE", label: "Active" },
  { value: "DEACTIVATED", label: "Deactivated" },
];

const ResourcePersonFilters = ({
  search,
  sort,
  status,
  onSearchSubmit,
  onSortChange,
  onStatusChange,
}) => {
  return (
    <div className="rounded-lg border border-slate-200 bg-white p-4 shadow-sm">
      <div className="flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
        <div className="flex min-h-11 w-full max-w-xl items-center gap-3 rounded-lg border border-slate-200 bg-slate-50 px-3 text-slate-500 focus-within:border-slate-400 focus-within:bg-white">
          <button
            type="button"
            className="border-0 bg-transparent p-0 text-slate-500"
            onClick={() => {
              const searchInput = document.querySelector(".searchBar2");
              if (searchInput) {
                onSearchSubmit(searchInput.value);
              }
            }}
            aria-label="Search resource persons"
          >
            <FontAwesomeIcon icon={faSearch} />
          </button>
          <input
            type="text"
            className="searchBar2 w-full bg-transparent text-sm text-slate-700 outline-none placeholder:text-slate-400"
            placeholder="Search resource person by name or email"
            defaultValue={search}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                onSearchSubmit(e.target.value);
              }
            }}
          />
        </div>

        <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
          <label className="flex min-h-11 items-center gap-2 rounded-lg border border-slate-200 bg-slate-50 px-3 text-sm text-slate-600">
            <FontAwesomeIcon icon={faFilter} className="text-slate-400" />
            <select
              className="min-w-36 border-0 bg-transparent text-sm text-slate-700 outline-none"
              value={status}
              onChange={(e) => onStatusChange(e.target.value)}
            >
              {STATUS_OPTIONS.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </label>

          <label className="flex min-h-11 items-center gap-2 rounded-lg border border-slate-200 bg-slate-50 px-3 text-sm text-slate-600">
            <FontAwesomeIcon icon={faSortAmountDown} className="text-slate-400" />
            <select
              className="min-w-44 border-0 bg-transparent text-sm text-slate-700 outline-none"
              value={sort}
              onChange={(e) => onSortChange(e.target.value)}
            >
              {SORT_OPTIONS.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </label>
        </div>
      </div>
    </div>
  );
};

export default ResourcePersonFilters;
